import React, { useState } from 'react';
import { Card } from '@common';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Cell,
  Tooltip,
} from 'recharts';

import BudgetChart from 'components/common/budgetChart/BudgetChart';

import RatingCard from 'components/common/rattingCard/RatingCard';
import TopClustersChart from 'components/common/topClustersChart/TopClustersChart';
import FilterComponent from '../../components/common/filterComponent/FilterComponent';
import apiService from 'services/apiService';

import './style.css';
import DashboardFilters from 'components/specific/DashboardFilters';
import FiltersProvider from 'components/specific/DashboardFilters/context/filters-context';
import { MedicalSpecialitie } from './components/MedicalSpecialities';
import { Practitioner } from './components/Practitioner';
import { VisitChart } from './components/VisitChart';
import { VisitedHos } from './components/VisitedHos';
import { RatingCards } from './components/Rating';
import { TerminationChart } from './components/Terminated';

const PieChartLine2 = ({ color = '#525866', className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C7.0293 21 3 16.9707 3 12C3 7.9698 5.6487 4.5588 9.3 3.4122V5.3238C7.75283 5.95204 6.47202 7.09834 5.67665 8.5666C4.88129 10.0349 4.62079 11.7339 4.93973 13.373C5.25866 15.0121 6.13721 16.4895 7.42509 17.5524C8.71297 18.6153 10.3301 19.1977 12 19.2C13.4344 19.2 14.8361 18.7716 16.0256 17.9699C17.215 17.1682 18.138 16.0296 18.6762 14.7H20.5878C19.4412 18.3513 16.0302 21 12 21ZM20.955 12.9H11.1V3.045C11.3961 3.0153 11.6967 3 12 3C16.9707 3 21 7.0293 21 12C21 12.3033 20.9847 12.6039 20.955 12.9ZM12.9 4.8558V11.1H19.1442C18.9439 9.51385 18.2216 8.0394 17.0911 6.90891C15.9606 5.77842 14.4862 5.05613 12.9 4.8558Z"
        fill={color}
      />
    </svg>
  );
};

const colors = ['#375DFB', '#35B9E9', '#6E3FF3', '#F2AE40', '#E255F2'];

const data = [
  {
    cluster: 'Cluster 1',
    uv: 400,
    pv: 240,
    amt: 240,
  },
  {
    cluster: 'Cluster 2',
    uv: 300,
    pv: 139,
    amt: 221,
  },
  {
    cluster: 'Cluster 3',
    uv: 200,
    pv: 980,
    amt: 229,
  },
  {
    cluster: 'Cluster 4',
    uv: 278,
    pv: 390,
    amt: 200,
  },
  {
    cluster: 'Cluster 5',
    uv: 189,
    pv: 480,
    amt: 218,
  },
];

function Dashboard() {
  const [topPractitioners, setTopPractitioners] = useState([]);
  const [MaleFemale, setMaleFemale] = useState('');
  const [topVisitedHospitals, setTopVisitedHospitals] = useState([]);
  const [topSpecialties, setTopSpecialties] = useState([]);
  const [totalPrac, setTotalPrac] = useState('');
  const [totalVisit, setTotalVisit] = useState('');
  const [totalVisitCount, setTotalVisitCount] = useState('');
  const [totalRating, setRating] = useState([]);
  const [totalTerminated, setTotalTerminated] = useState('');
  const [totalTerminatedMAx, setTotalTerminatedMax] = useState('');

  const user = JSON.parse(localStorage.getItem('user'));

  const [visitFilter, setVisit] = React.useState('current_week');
  const [ratingFilter, setRatingFiter] = React.useState('current_week');

  const ref = React.useRef(null);
  const [dropdown, setDropdown] = useState(false);

  const [filters, setFilters] = useState({});

  const [Localfilters, setLocalFilters] = useState({});
  const [LocalfiltersSpecialties, setLocalFiltersSpecialties] = useState({});
  const [LocalfiltersVisit, setLocalfiltersVisit] = useState({});
  const [LocalfiltersVisitedHospital, setLocalfiltersVisitedHospital] =
    useState({});
  const [LocalfiltersRating, setLocalfiltersRating] = useState({});
  const [LocalfiltersTerminated, setLocalfiltersTerminated] = useState({});

  const ToolTip = ({ active, payload, coordinate }) => {
    if (!active || !payload || !payload.length) return null;

    const { x, y } = coordinate || {};

    return (
      <div
        className="absolute h-7 px-2.5 py-1 bg-[#20232d] rounded-md shadow-[0px_1px_2px_0px_rgba(228,229,231,0.24)] shadow-[0px_12px_24px_0px_rgba(134,140,152,0.12)] justify-center items-center gap-1.5 inline-flex text-white text-sm font-normal font-['Inter'] leading-tight
        before:content-[''] before:w-[0.69vw] before:h-[1.11vh] before:bg-[#20232d] before:absolute before:top-[22px] before:right-[20px] before:rotate-45"
        style={{
          left: x,
          top: y - 40,
          transform: 'translateX(-50%)',
          position: 'absolute',
          pointerEvents: 'none',
        }}
      >
        {payload?.[0]?.payload?.visit_count
          ? payload?.[0]?.payload?.visit_count
          : 2400}
      </div>
    );
  };

  const fetchData = async (additional, LocalfiltersSpecialties) => {
    const startDateObj = additional?.DATE?.find(
      (item) => item?.name === 'startDate'
    );
    const endDateObj = additional?.DATE?.find(
      (item) => item?.name === 'endDate'
    );

    const startDate = startDateObj ? startDateObj._id : ''; // '2025-02-20'
    const endDate = endDateObj ? endDateObj._id : ''; // '2025-02-28'

    // Extract region (assuming it contains IDs)
    const regions =
      additional?.REGIONS?.length > 0
        ? additional?.REGIONS?.map((region) => region?._id)
        : [];

    const localDates = LocalfiltersSpecialties?.DATE || []; // Ensure it's an array
    const localRegions = LocalfiltersSpecialties?.REGIONS || []; // Ensure it's an array

    // Extract local start and end dates
    const localStartDatePrac =
      localDates.find((item) => item?.name === 'startDate')?._id || '';
    const localEndDatePrac =
      localDates.find((item) => item?.name === 'endDate')?._id || '';

    // Extract local region IDs
    const localRegionIds = localRegions.map((region) => region?._id) || [];

    try {
      const [
        response1,
        response2,
        response3,
        response4,
        response5,
        response6,
        response7,
      ] = await Promise.allSettled([
        apiService.get(
          `/physician-dashboard/terminated-contracts?start_date=${startDate}&end_date=${endDate}&local_start_date=&local_end_date=&region=${JSON.stringify(regions)}`
        ),
        apiService.get(
          `/physician-dashboard/visits?start_date=${startDate}&end_date=${endDate}&local_start_date=&local_end_date=&region=${JSON.stringify(regions)}`
        ),
        apiService.get(
          `/physician-dashboard/rating?start_date=${startDate}&end_date=${endDate}&local_start_date=&local_end_date=&region=${JSON.stringify(regions)}`
        ),
        apiService.get(
          `/physician-dashboard/top-hospitals?start_date=${startDate}&end_date=${endDate}&local_start_date=&local_end_date=&region=${JSON.stringify(regions)}`
        ),
        apiService.get(
          `/dashboard/top-med-specialties?start_date=${startDate}&end_date=${endDate}&local_start_date=&local_end_date=&region=${JSON.stringify(regions)}`
        ),
        apiService.get(
          `/dashboard/top_practitioners?start_date=${startDate}&end_date=${endDate}&local_start_date=${localStartDatePrac}&local_end_date=${localEndDatePrac}&region=${JSON.stringify(regions)}`
        ),
        apiService.get(
          `/dashboard/data?start_date=${startDate}&end_date=${endDate}&local_start_date=&local_end_date=&region=${JSON.stringify(regions)}`
        ),
      ]);

      if (response1.status === 'fulfilled') {
        setTotalTerminated(
          response1.value?.original?.terminated_contracts_count
        );
        setTotalTerminatedMax(response1.value?.original?.total_contracts);
      }

      if (response2.status === 'fulfilled') {
        setTotalVisit(response2.value?.original?.total_number_of_visits);
        setTotalVisitCount(response2.value?.original?.total_visits_count);
      }

      if (response3.status === 'fulfilled') {
        const filteredContracts =
          response3.value?.original?.physician_rating?.filter(
            (contract) => contract.ratings.length > 0
          );
        setRating(filteredContracts);
      }

      if (response4.status === 'fulfilled') {
        setTopVisitedHospitals(
          response4?.value?.original?.top_visited_hospitals
        );
      }
      if (response5.status === 'fulfilled') {
        console.log('Top Specialties:', response5?.value?.data);
        setTopSpecialties(response5?.value?.data?.top_specialties);
        setTotalPrac(response5?.value?.data?.registered_physician);
      }
      if (response6.status === 'fulfilled') {
        setTopPractitioners(response6?.value?.data?.top_practitioners);
      }
      if (response7.status === 'fulfilled') {
        setMaleFemale(response7?.value?.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDatalocalPractitioners = async (LocalfiltersSpecialties) => {
    const startDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'startDate'
    );
    const endDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'endDate'
    );

    const startDate = startDateObj ? startDateObj._id : ''; // '2025-02-20'
    const endDate = endDateObj ? endDateObj._id : ''; // '2025-02-28'

    // Extract region (assuming it contains IDs)
    const regions =
      LocalfiltersSpecialties?.REGIONS?.length > 0
        ? LocalfiltersSpecialties?.REGIONS?.map((region) => region?._id)
        : [];

    console.log('Start Date:', LocalfiltersSpecialties);

    try {
      const [response6] = await Promise.allSettled([
        apiService.get(
          `/dashboard/top_practitioners?start_date=&end_date=&local_start_date=${startDate} &local_end_date=${endDate} &region=${JSON.stringify(regions)}`
        ),
      ]);

      if (response6.status === 'fulfilled') {
        setTopPractitioners(response6?.value?.data?.top_practitioners);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDatalocalSpecialties = async (LocalfiltersSpecialties) => {
    const startDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'startDate'
    );
    const endDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'endDate'
    );

    const startDate = startDateObj ? startDateObj._id : ''; // '2025-02-20'
    const endDate = endDateObj ? endDateObj._id : ''; // '2025-02-28'

    // Extract region (assuming it contains IDs)
    const regions =
      LocalfiltersSpecialties?.REGIONS?.length > 0
        ? LocalfiltersSpecialties?.REGIONS?.map((region) => region?._id)
        : [];

    console.log('Start Date:', LocalfiltersSpecialties);

    try {
      const [response5] = await Promise.allSettled([
        apiService.get(
          `/dashboard/top-med-specialties?start_date=&end_date=&local_start_date=${startDate} &local_end_date=${endDate} &region=${JSON.stringify(regions)}`
        ),
      ]);

      if (response5.status === 'fulfilled') {
        setTopSpecialties(response5?.value?.data?.top_specialties);
        setTotalPrac(response5?.value?.data?.registered_physician);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataVisit = async (LocalfiltersSpecialties) => {
    const startDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'startDate'
    );
    const endDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'endDate'
    );

    const startDate = startDateObj ? startDateObj._id : ''; // '2025-02-20'
    const endDate = endDateObj ? endDateObj._id : ''; // '2025-02-28'

    // Extract region (assuming it contains IDs)
    const regions =
      LocalfiltersSpecialties?.REGIONS?.length > 0
        ? LocalfiltersSpecialties?.REGIONS?.map((region) => region?._id)
        : [];

    console.log('Start Date:', LocalfiltersSpecialties);

    try {
      const [response2] = await Promise.allSettled([
        apiService.get(
          `/physician-dashboard/visits?start_date=&end_date=&local_start_date=${startDate} &local_end_date=${endDate} &region=${JSON.stringify(regions)}`
        ),
      ]);

      if (response2.status === 'fulfilled') {
        setTotalVisit(response2.value?.original?.total_number_of_visits);
        setTotalVisitCount(response2.value?.original?.total_visits_count);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataVisitedHos = async (LocalfiltersSpecialties) => {
    const startDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'startDate'
    );
    const endDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'endDate'
    );

    const startDate = startDateObj ? startDateObj._id : ''; // '2025-02-20'
    const endDate = endDateObj ? endDateObj._id : ''; // '2025-02-28'

    // Extract region (assuming it contains IDs)
    const regions =
      LocalfiltersSpecialties?.REGIONS?.length > 0
        ? LocalfiltersSpecialties?.REGIONS?.map((region) => region?._id)
        : [];

    const regionQuery = regions.map((id) => `region[]=${id}`).join('&');

    try {
      const [response4] = await Promise.allSettled([
        apiService.get(
          `/physician-dashboard/top-hospitals?start_date=&end_date=&local_start_date=${startDate} &local_end_date=${endDate} &region=${JSON.stringify(regions)}`
        ),
      ]);

      if (response4.status === 'fulfilled') {
        setTopVisitedHospitals(
          response4?.value?.original?.top_visited_hospitals
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataRating = async (LocalfiltersSpecialties) => {
    const startDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'startDate'
    );
    const endDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'endDate'
    );

    const startDate = startDateObj ? startDateObj._id : ''; // '2025-02-20'
    const endDate = endDateObj ? endDateObj._id : ''; // '2025-02-28'

    // Extract region (assuming it contains IDs)
    const regions =
      LocalfiltersSpecialties?.REGIONS?.length > 0
        ? LocalfiltersSpecialties?.REGIONS?.map((region) => region?._id)
        : [];

    console.log('Start Date:', LocalfiltersSpecialties);

    try {
      const [response3] = await Promise.allSettled([
        apiService.get(
          `/physician-dashboard/rating?start_date=&end_date=&local_start_date=${startDate} &local_end_date=${endDate} &region=${JSON.stringify(regions)}`
        ),
      ]);

      if (response3.status === 'fulfilled') {
        const filteredContracts =
          response3.value?.original?.physician_rating?.filter(
            (contract) => contract.ratings.length > 0
          );
        setRating(filteredContracts);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataTerminated = async (LocalfiltersSpecialties) => {
    const startDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'startDate'
    );
    const endDateObj = LocalfiltersSpecialties?.DATE?.find(
      (item) => item?.name === 'endDate'
    );

    const startDate = startDateObj ? startDateObj._id : ''; // '2025-02-20'
    const endDate = endDateObj ? endDateObj._id : ''; // '2025-02-28'

    // Extract region (assuming it contains IDs)
    const regions =
      LocalfiltersSpecialties?.REGIONS?.length > 0
        ? LocalfiltersSpecialties?.REGIONS?.map((region) => region?._id)
        : [];

    console.log('Start Date:', LocalfiltersSpecialties);

    try {
      const [response1] = await Promise.allSettled([
        apiService.get(
          `/physician-dashboard/terminated-contracts?start_date=&end_date=&local_start_date=${startDate} &local_end_date=${endDate} &region=${JSON.stringify(regions)}`
        ),
      ]);

      if (response1.status === 'fulfilled') {
        setTotalTerminated(
          response1.value?.original?.terminated_contracts_count
        );
        setTotalTerminatedMax(response1.value?.original?.total_contracts);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  React.useEffect(() => {
    fetchDataTerminated(LocalfiltersTerminated);
  }, [LocalfiltersTerminated]);
  React.useEffect(() => {
    fetchDataRating(LocalfiltersRating);
  }, [LocalfiltersRating]);

  React.useEffect(() => {
    fetchDataVisitedHos(LocalfiltersVisitedHospital);
  }, [LocalfiltersVisitedHospital]);

  React.useEffect(() => {
    fetchDataVisit(LocalfiltersVisit);
  }, [LocalfiltersVisit]);

  React.useEffect(() => {
    fetchDatalocalPractitioners(LocalfiltersSpecialties);
  }, [LocalfiltersSpecialties]);
  React.useEffect(() => {
    fetchDatalocalSpecialties(Localfilters);
  }, [Localfilters]);
  React.useEffect(() => {
    fetchData(filters);
  }, [filters]);

  React.useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  return (
    <>
      <FiltersProvider>
        <DashboardFilters id="filters-1" setFilters={setFilters} />
      </FiltersProvider>

      <section className="flex p-[2vh] gap-2 w-fit  mx-auto w-[77.8vw]">
        {user.role === 'physician_management' ? (
          <section className="p-[2vh] w-full overflow-hidden">
            <div className="grid  grid-cols-2 gap-4">
              <VisitChart
                setLocalfiltersVisit={setLocalfiltersVisit}
                totalVisit={totalVisit}
                totalVisitCount={totalVisitCount}
                setVisit={setVisit}
              />

              <div>
                <VisitedHos
                  data={topVisitedHospitals}
                  setLocalfiltersVisitedHospital={
                    setLocalfiltersVisitedHospital
                  }
                />
              </div>

              <div>
                <RatingCards
                  totalRating={totalRating}
                  setRatingFiter={setRatingFiter}
                  setLocalfiltersRating={setLocalfiltersRating}
                />
              </div>
              <TerminationChart
                setLocalfiltersTerminated={setLocalfiltersTerminated}
                totalTerminated={totalTerminated}
                totalTerminatedMAx={totalTerminatedMAx}
              />
            </div>
          </section>
        ) : (
          <>
            <div className="grid grid-cols-2 gap-2 h-full">
              <div>
                <Card className=" w-[100%] h-[100%] top-0 left-0 bg-white rounded-[20px] border border-solid border-[#e2e4e9]">
                  <Card.Header className="flex w-[34.5vw] items-center gap-4 ">
                    <div className="flex w-[16vw] items-start gap-2 px-0  pt-[2.56vh] mb-[0.44vh]">
                      <PieChartLine2
                        className="!w-6 !h-6 ml-[1.11vw]"
                        color="#525866"
                      />
                      <p className="text-[#0A0D14] font-[Inter] text-[1rem] font-medium leading-[2.67vh] tracking-[-0.176px]">
                        Total Budget Received
                      </p>
                    </div>
                  </Card.Header>
                  <div className="w-full flex items-center justify-center ">
                    <div className="bg-[#E2E4E9] h-[0.11vh] rounded-full w-[95%]  box-border" />
                  </div>
                  <Card.Body className="pt-[2.67vh] ml-[1.18vw]">
                    <div>
                      <h3 className="text-[#868C98] [font-family:'Mazzard',Helvetica] text-[1.25rem] font-light leading-[2.67vh] m-0 h-[2.67vh]">
                        SAR
                      </h3>
                      <div className="flex justify-stretch">
                        <div>
                          <p className="m-0 [font-family:'Mazzard',Helvetica] text-[#0A0D14] text-[2rem] font-semibold leading-[5.33vh] h-[4.22vh]">
                            2,826,873
                          </p>
                        </div>
                        <div>
                          <p className="relative text-[#2D9F75] font-[Inter] text-[0.875rem] font-medium leading-[2.22vh] tracking-[-0.084px] mb-0 !mr-[-3.19vw] ml-[5.83vw] before:content-[''] before:w-[1.25vw] before:h-[2vh] before:bg-[#2D9F75] before:rounded-full before:absolute before:left-[-1.81vw] before:top-1/2 before:-translate-y-1/2">
                            <span className="absolute left-[-1.53vw] top-1/2 -translate-y-1/2 w-[0.63vw] h-[1vh] flex items-center justify-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="9"
                                height="9"
                                viewBox="0 0 10 10"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_228_14512)">
                                  <path
                                    d="M9.17414 1.8894L9.16149 1.8894L5.61071 2.03002C5.5242 2.03343 5.44257 2.07103 5.38377 2.13458C5.32497 2.19813 5.2938 2.28242 5.29711 2.36893C5.30077 2.45535 5.33846 2.53682 5.40194 2.59557C5.46543 2.65431 5.54958 2.68557 5.63602 2.68252L8.83383 2.55596L8.70727 5.75377C8.70024 5.93377 8.84086 6.08565 9.02086 6.09268C9.19946 6.0969 9.35274 5.95909 9.35977 5.77909L9.50039 2.2283C9.50461 2.1369 9.46946 2.04971 9.40477 1.98502C9.34289 1.92455 9.26133 1.8894 9.17414 1.8894Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M9.17427 1.88907C9.0913 1.88907 9.00692 1.92142 8.94364 1.9847L4.53364 6.3961L3.21599 5.0461C3.15271 4.98142 3.06271 4.94485 2.97271 4.94767C2.8813 4.95048 2.79552 4.99126 2.73505 5.06157L0.579268 7.57173C0.462549 7.70813 0.478018 7.91485 0.614424 8.03157C0.750831 8.14829 0.956143 8.13282 1.07427 7.99642L2.99802 5.75626L4.29739 7.08798C4.35786 7.14985 4.44224 7.18642 4.52802 7.18642L4.52942 7.18642C4.61661 7.18642 4.69817 7.15267 4.76005 7.09079L9.40349 2.44735C9.53146 2.31938 9.53146 2.11407 9.40349 1.9861C9.34161 1.92142 9.25724 1.88907 9.17427 1.88907Z"
                                    fill="white"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_228_14512">
                                    <rect
                                      width="9"
                                      height="9"
                                      fill="white"
                                      transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0.5 9.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            23%
                          </p>
                          <p className="text-[#868C98] font-[Inter] text-[0.75rem] font-normal leading-[1.78vh] mb-0 !mr-[-3.19vw] ml-[4.17vw]">
                            from last year
                          </p>
                        </div>
                      </div>
                      <div className="flex justify-stretch mt-[2.44vh]">
                        <p className="text-[#868C98] font-[Inter] text-[0.6875rem] font-medium leading-[1.33vh] tracking-[0.22px] uppercase mb-0 self-center">
                          Deposited Charity
                        </p>
                        <p className="text-[#0A0D14] text-[1.125rem] font-semibold leading-[3vh] [font-family:'Mazzard',Helvetica] mb-0 ml-[1.11vw] !mr-[-4.79vw]">
                          <span className="text-[#868C98] text-[1.125rem] font-semibold leading-[3vh] mr-[0.28vw]">
                            SAR
                          </span>
                          3,000,000
                        </p>
                      </div>
                      <div className="w-[23.65vw] h-[4vh] border border-[#E2E4E9] rounded-[5px] flex-shrink-0 flex gap justify-around items-center mt-[1.11vh]">
                        <div className="w-[13.15vw] h-[2vh] bg-[#6E3FF3] rounded-[5px] flex-shrink-0 self-center " />
                        <div className="w-[8.87vw] h-[2vh] flex-shrink-0 rounded-[5px] bg-[#E255F2] self-center " />
                      </div>
                      <div className="flex justify-stretch mt-[2.67vh]">
                        <span className="flex gap-2 items-center ">
                          <div className="w-[1.25vw] h-[2vh] bg-[#6E3FF3] rounded-[5px] " />
                          <p className="m-0 self-center text-[#868C98] font-[Inter] text-[0.6875rem] font-medium leading-[1.33vh] tracking-[0.22px] uppercase">
                            REMAINING BUDGET
                          </p>
                        </span>
                        <p className="text-[#0A0D14]  text-[1.125rem] font-semibold leading-normal mb-0 !mr-[-3.19vw] ml-[0.69vw]">
                          <span className="text-[#868C98]  text-[1.125rem] font-semibold leading-normal mr-[0.28vw]">
                            SAR
                          </span>
                          247,608,630
                        </p>
                      </div>
                      <div className="flex justify-stretch mt-[2.11vh]">
                        <span className="flex gap-2 items-center ">
                          <div className="w-[1.25vw] h-[2vh] bg-[#E255F2] rounded-[5px] " />
                          <p className=" m-0 self-center text-[#868C98] font-[Inter] text-[0.6875rem] font-medium leading-[1.3333333333333335vh] tracking-[0.22px] uppercase">
                            ALLOCATED BUDGET
                          </p>
                        </span>
                        <p className="text-[#0A0D14]  text-[1.125rem] font-semibold leading-normal mb-0 !mr-[-3.19vw] ml-[0.69vw]">
                          <span className="text-[#868C98]  text-[1.125rem] font-semibold leading-normal mr-[0.2777777777777778vw]">
                            SAR
                          </span>
                          147,511,524
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              <div>
                <Card className=" w-[100%] h-[100%] top-0 left-0 bg-white rounded-[20px] border border-solid border-[#e2e4e9]">
                  <Card.Header className="flex w-full items-center gap-4 ">
                    <div className="flex  items-start gap-2 px-0  pt-[23px] w-[97%] mb-[0.4444444444444444vh]">
                      <PieChartLine2
                        className=" !w-6 !h-6 ml-[1.1111111111111112vw]"
                        color="#525866"
                      />
                      <div className="flex justify-between items-center w-full">
                        <p className="text-[#0A0D14] font-[Inter] text-[1rem] font-medium leading-[2.666666666666667vh] tracking-[-0.176px]">
                          Top 5 Cluster with High Budgets
                        </p>
                      </div>
                    </div>
                  </Card.Header>
                  <div className="w-full flex items-center justify-center ">
                    <div className="bg-[#E2E4E9] h-[0.1111111111111111vh] rounded-full w-[95%]  box-border" />
                  </div>
                  <Card.Body className="w-[190px] ml-[0.69vw] mt-[1.11vh]">
                    <div className={'w-[200px]'}>
                      <BarChart
                        width={window.innerWidth * 0.24}
                        height={window.innerHeight * 0.33}
                        data={data}
                        barSize={16}
                        radius={[0, 0, 0, 0]}
                        layout="vertical"
                      >
                        <CartesianGrid
                          strokeDasharray="1 3"
                          vertical={true}
                          horizontal={false}
                        />
                        <XAxis
                          type="number"
                          dataKey="amt"
                          axisLine={false}
                          tickLine={false}
                          tick={{
                            fill: 'var(--text-soft-400, #868C98)',
                            fontFamily: 'Inter',
                            fontSize: 11,
                            fontWeight: 500,
                            letterSpacing: '0.22px',
                            textTransform: 'uppercase',
                            textAnchor: 'middle',
                          }}
                        />
                        <YAxis
                          dataKey="cluster"
                          type="category"
                          width={85}
                          axisLine={false}
                          tickLine={false}
                          tick={{
                            fill: 'var(--text-sub-500, #525866)',
                            fontFamily: 'Inter',
                            fontSize: 14,
                            fontWeight: 400,
                            lineHeight: '20px',
                            letterSpacing: '-0.084px',
                            dx: -20,
                          }}
                        />
                        <Tooltip content={<ToolTip />} />
                        <Bar dataKey="uv">
                          {data.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={colors[index]}
                              style={{ transition: 'none' }}
                              activeBar={false}
                            />
                          ))}
                        </Bar>
                      </BarChart>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              <div>
                <Card className="w-[100%] h-[100%] top-0 left-0 bg-white rounded-[20px] border border-solid border-[#e2e4e9]">
                  <Card.Header className="flex w-[34.513888888888886vw] items-center gap-4 ">
                    <div className="flex  items-start gap-2 px-0  pt-[23px] mb-[0.4444444444444444vh]">
                      <PieChartLine2
                        className=" !w-6 !h-6 ml-[1.1111111111111112vw]"
                        color="#525866"
                      />
                      <p className="text-[#0A0D14] font-[Inter] text-[1rem] font-medium leading-[2.666666666666667vh] tracking-[-0.176px]">
                        Top 5 Consuming Clusters
                      </p>
                    </div>
                  </Card.Header>
                  <div className="w-full flex items-center justify-center ">
                    <div className="bg-[#E2E4E9] h-[0.1111111111111111vh] rounded-full w-[95%]  box-border" />
                  </div>
                  <Card.Body className="relative  top-[-74px]">
                    <div className="w-[372px] h-96">
                      <div className="w-[131px] h-[131px] left-[58px] top-[228px] absolute bg-[#fdebff] rounded-full shadow-[inset_10px_10px_10px_0px_rgba(249,194,255,1.00)]" />
                      <div className="w-[65px] h-[65px] left-[193px] top-[277px] absolute bg-[#ebfaff] rounded-full shadow-[inset_10px_10px_10px_0px_rgba(194,239,255,1.00)]" />
                      <div className="w-[38px] h-[38px] left-[164px] top-[97px] absolute bg-[#fef7ec] rounded-full shadow-[inset_10px_10px_10px_0px_rgba(251,223,177,1.00)]" />
                      <div className="w-[145px] h-[145px] left-[169px] top-[127px] absolute">
                        <div className="w-[145px] h-[145px] left-0 top-0 absolute bg-[#eeebff] rounded-full shadow-[inset_10px_10px_10px_0px_rgba(202,194,255,1.00)]" />
                        <div className="w-[50px] h-[43px] left-[49px] top-[52px] absolute">
                          <div className="left-[4px] top-0 absolute">
                            <span class="text-[#2b1664] text-2xl font-normal font-['Inter'] leading-loose">
                              80
                            </span>
                            <span class="text-[#2b1664] text-base font-medium font-['Inter'] leading-normal">
                              %
                            </span>
                          </div>
                          <div className="left-0 top-[32px] absolute text-[#2b1664] text-xs font-normal font-['Inter'] leading-none">
                            Cluster 1
                          </div>
                        </div>
                      </div>
                      <div className="w-[118px] h-[118px] left-[43px] top-[103px] absolute">
                        <div className="w-[118px] h-[118px] left-0 top-0 absolute bg-[#effaf6] rounded-full shadow-[inset_10px_10px_10px_0px_rgba(203,245,229,1.00)]" />
                        <div className="w-[52px] h-[43px] left-[33px] top-[38px] absolute">
                          <div className="left-[4px] top-0 absolute">
                            <span class="text-[#176448] text-2xl font-normal font-['Inter'] leading-loose">
                              50
                            </span>
                            <span class="text-[#176448] text-base font-medium font-['Inter'] leading-normal">
                              %
                            </span>
                          </div>
                          <div className="left-0 top-[32px] absolute text-[#176448] text-xs font-normal font-['Inter'] leading-none">
                            Cluster 2
                          </div>
                        </div>
                      </div>
                      <div className="w-[52px] h-11 left-[98px] top-[272px] absolute">
                        <div className="w-[41px] left-[8px] top-0 absolute">
                          <span class="text-[#620f6c] text-2xl font-normal font-['Inter'] leading-loose">
                            75
                          </span>
                          <span class="text-[#620f6c] text-base font-medium font-['Inter'] leading-normal">
                            %
                          </span>
                        </div>
                        <div className="left-0 top-[32px] absolute text-[#620f6c] text-xs font-normal font-['Inter'] leading-none">
                          Cluster 3
                        </div>
                      </div>
                      <div
                        data-svg-wrapper
                        className="left-[203px] top-[102px] absolute"
                      >
                        <svg
                          width="38"
                          height="8"
                          viewBox="0 0 38 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M1 7L7.5 1H37.5" stroke="#CDD0D5" />
                        </svg>
                      </div>
                      <div
                        data-svg-wrapper
                        className="left-[225px] top-[353px] absolute"
                      >
                        <svg
                          width="38"
                          height="8"
                          viewBox="0 0 38 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M1 1L7.5 7L37.5 7" stroke="#CDD0D5" />
                        </svg>
                      </div>
                      <div className="w-[54px] left-[246px] top-[82px] absolute text-[#0a0d14] text-lg font-medium font-['Inter'] leading-normal">
                        13 %
                      </div>
                      <div className="w-[54px] left-[268px] top-[321px] absolute text-[#0a0d14] text-lg font-medium font-['Inter'] leading-normal">
                        11 %
                      </div>
                      <div className="w-[82px] left-[246px] top-[106px] absolute text-[#868c98] text-xs font-medium font-['Inter'] leading-none">
                        CLUSTER 4
                      </div>
                      <div className="w-[82px] left-[268px] top-[345px] absolute text-[#868c98] text-xs font-medium font-['Inter'] leading-none">
                        CLUSTER 5
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              <div>
                <Practitioner
                  topPractitioners={topPractitioners}
                  setLocalFiltersSpecialties={setLocalFiltersSpecialties}
                />
              </div>
              <div>
                <Card className="w-[100%] h-[100%] top-0 left-0 bg-white rounded-[20px] border border-solid border-[#e2e4e9]">
                  <Card.Header className="flex  items-center gap-4 ">
                    <div className="flex  items-start gap-2 px-0  pt-[23px] mb-[0.4444444444444444vh]">
                      <PieChartLine2
                        className=" !w-6 !h-6 ml-[1.1111111111111112vw]"
                        color="#525866"
                      />
                      <p className="text-[#0A0D14] font-[Inter] text-[1rem] font-medium leading-[2.666666666666667vh] tracking-[-0.176px]">
                        Male Female Hiring
                      </p>
                    </div>
                  </Card.Header>
                  <div className="w-full flex items-center justify-center ">
                    <div className="bg-[#E2E4E9] h-[0.1111111111111111vh] rounded-full w-[95%]  box-border" />
                  </div>
                  <Card.Body className="h-[70%]">
                    <BudgetChart MaleFemale={MaleFemale}> </BudgetChart>
                  </Card.Body>
                </Card>
              </div>

              <div></div>
            </div>

            <div>
              <MedicalSpecialitie
                totalPrac={totalPrac}
                topSpecialties={topSpecialties}
              />
            </div>
          </>
        )}
      </section>
    </>
  );
}

export default Dashboard;

// <div className="">

//   <div className="dashboardFilters--dropdown">
//     <button
//       aria-expanded={dropdown.toString()}
//       onClick={toggleDropDown}
//       className="dashboardFilters--dropdown--toggle"
//     >
//       <AppIcon icon={plusIcon} className="pl-1" />
//       <span className="dashboardFilters--dropdown--toggle--text pr-1">
//         Add Filter
//       </span>
//     </button>
//     <MainFilters
//       dropdown={dropdown}
//       depthLevel={depthLevel}
//       toggleDropDown={toggleDropDown}
//       handleDateSelection={date.handleDateSelection}
//     />
//   </div>
//   {state.map((list, index) => {
//     const valuesCount = 0;

//     const tooltipContent =
//       list.title === 'Date'
//         ? Object.values(list.selectedList || {}).join(', ')
//         : Object.keys(list.selectedList || {}).join(', ');

//     return Object.entries(list.selectedList).length > 0 ? (
//       <div
//         key={index}
//         className={`dashboardFilters--showcase--selectedFilters--item ${valuesCount > 3 ? 'overflow' : ''
//           }`}
//       >
//         <span className="dashboardFilters--showcase--selectedFilters--item--key"

//           data-tooltip-id={`selected-filters-tooltip-${index}`}
//           data-tooltip-content={tooltipContent}

//         >
//           {list.title}:
//         </span>

//         <ReactTooltip id={`selected-filters-tooltip-${index}`} place="top" effect="solid" />

//         <AppIcon
//           icon={crossIcon}
//           onClick={() => {
//             if (list.title === 'Date') {
//               date.removeDate();
//             } else {
//               dispatch[index]({ type: 'REMOVE_SELECTED' });
//             }
//           }}
//           className="dashboardFilters--showcase--selectedFilters--item--icon"
//         />
//       </div>
//     ) : null;
//   })}
// </div>
